var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1719 16.5781L1.54688 5.95312C0.765625 5.17188 0.765625 4 1.54688 3.29688L3.26562 1.5C4.04688 0.796875 5.21875 0.796875 5.92188 1.5L13.4219 9.07812L21 1.5C21.7031 0.796875 22.875 0.796875 23.6562 1.5L25.375 3.29688C26.1562 4 26.1562 5.17188 25.375 5.95312L14.75 16.5781C14.0469 17.2812 12.875 17.2812 12.1719 16.5781Z",
    fill: "#478F96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.691b5e7e95a6f21b43d6f32c67bcb22a.svg";
export { ForwardRef as ReactComponent };